"use strict";

class RoleOverviewCtrl {

	constructor ($scope, $rootScope, $http, $state, Role, $mdDialog, $mdToast, paginationService, $transitions ) {

		// Dependencies
		this.$http = $http;
		this.$state = $state;
		this.$mdDialog = $mdDialog;
		this.$mdToast = $mdToast;
		this.paginationService = paginationService;
        this._Role = Role;

		// Paginator
		this.pagination = {
			current: 1
		};

		// Watchers
        $rootScope.checkActive = (role) => {
            return role.id == $state.params.id;
        };

        let unregister = $transitions.onSuccess({ }, function(transition) {

            let toState = transition.to();
            if( toState.name === 'role' ) {
                this.fetch();
            }
        });

        $scope.$on('$destroy', () => {
            unregister();
        });

        // Fetch overview items
        this.fetch(1);
	}

	fetch(pageNumber) {
		this.$http.get('/roles_overview/?page=' + pageNumber)
			.then((response) => {
				this.roles = response.data.data;
				this.totalResults = response.data.total;
				this.resultPerPage = response.data.per_page;
			});

		// this.pageChanged = function(newPage) {
		// 	getResultsPage(newPage);
		// };
	}

	destroy(id, name, ev) {

		ev.stopPropagation();

		this.$mdDialog.show( {

			controller: 'ConfirmDialogCtrl',
			templateUrl: "confirmDialog.ngTemplate",
			parent: angular.element(document.querySelector('#popupContainer')),
			targetEvent: ev,
			clickOutsideToClose: true
		}).then( () => {

			this._Role.delete({id: id}, () => {
				this.fetch(this.pagination.current);
				// this.fetch(this.paginationService.getCurrentPage('__default'));
			});

			this.$mdToast.show({
				templateUrl: '/partial/app.partials.toasts.delete?object=role&title='+name, //@trans('labels.role')
				hideDelay: 3000,
				position: ('top right')
			});
		});
	}
}

RoleOverviewCtrl.$inject = ['$scope', '$rootScope', '$http', '$state', 'Role', '$mdDialog' , '$mdToast', 'paginationService', '$transitions'];

module.exports = RoleOverviewCtrl;
